import router from './router'
import { TOKEN } from './constants'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getSession } from './utils'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/pay/result/:orderNo', '/mobile/delivery/detail/:vehiclePolicyId/:phone', '/mobile/delivery/list/:phone/:type']

let isLoaded = false

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (getSession(TOKEN)) {
    if (to.path === '/login') {
      if (!isLoaded) {
        next({ path: '/' })
      } else {
        next(false)
        NProgress.done()
        isLoaded = true
      }
    } else {
      next()
    }
  } else {
    /* has no token */
    if (isWhite(whiteList, to)) {
      next()
    } else {
      next(`/login?redirect=${encodeURIComponent(to.path === '/404' ? '/' : to.path)}`)
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

function isWhite (whiteList, to) {
  for (const whitePath of whiteList) {
    const resolvedPath = whitePath.replace(/:([^/]+)/g, function (match, key, index, src) {
      return to.params[key] || ''
    })
    if (resolvedPath === to.path) return true
  }
  return false
}
